import { CASH_LANES } from "@/lib/homeExtras";
import { SectionHead, SHELL, Reveal } from "@/components/bits";

const STEPS = (lane) => [lane.src, lane.event, "CASH FLOW", "CAPITAL"];

export default function CashFlow() {
    return (
        <section className="relative py-24 md:py-32 bg-vera-bg2/30 border-y border-white/10" data-testid="cashflow-section">
            <SHELL>
                <SectionHead
                    index="05"
                    label="CASH FLOW ENGINE"
                    title={"CASH FLOW IS THE REAL ENGINE."}
                    sub="Assets matter because they produce economic activity. VERA is built to structure that activity into capital that can move and settle."
                />
                <div className="grid md:grid-cols-3 gap-5">
                    {CASH_LANES.map((lane, laneIdx) => (
                        <Reveal key={lane.id} delay={laneIdx * 0.08}>
                            <div className="glass-card p-7" data-testid={`cashflow-lane-${lane.id}`}>
                                <div className="flex flex-col">
                                    {STEPS(lane).map((s, i) => (
                                        <div key={s} className="w-full">
                                            <div
                                                className={`px-4 py-3.5 border font-mono text-[10px] tracking-[0.22em] text-center ${s === "CASH FLOW" ? "border-vera-gold/60 text-vera-gold2 bg-vera-gold/10" : s === "CAPITAL" ? "border-vera-blue/50 text-[#A8D2FF] bg-vera-blue/10" : "border-white/12 text-vera-mut"}`}
                                            >
                                                {s}
                                            </div>
                                            {i < 3 && (
                                                <div className="relative h-9 w-px bg-white/10 mx-auto overflow-hidden" aria-hidden="true">
                                                    <span className="flow-dot" style={{ "--flow-dist": "36px", animationDelay: `${i * 0.65 + laneIdx * 0.3}s` }} />
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </SHELL>
        </section>
    );
}
